export const getLineGeojsonFromPoints = (points) => ({ "type": "FeatureCollection",
    "features": [
          { "type": "Feature",
              "geometry": {
                  "type": "LineString",
                  "coordinates": points,
              },
          },
      ],
});

export const getPointsGeojsonFromPoints = (points) => ({
    "type": "FeatureCollection",
    "features": points.map((p, index) => ({
        "type": "Feature",
        "properties": {
            "index": index,
        },
        "geometry": {
            "type": "Point",
            "coordinates": p,
        },
    })),
});
  
export const getPointsFromGeojson = (points) => ({ "type": "FeatureCollection",
    "features": [
          { "type": "Feature",
              "geometry": {
                  "type": "LineString",
                  "coordinates": points,
              },
          },
      ],
});